"use client";

import { motion } from "motion/react";
import { useTranslation } from "react-i18next";
import { GlassCard } from "@/src/components/GlassCard";
import { HOME_INDUSTRY_ITEMS } from "../home.data";

// * ─── Industries We Serve ────────────────────────────────────────────────────
export function HomeIndustriesSection() {
  const { t } = useTranslation("common");

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-walnut-900 dark:text-white mb-4">
            {t("industries.title")}
          </h2>
          <p className="text-lg text-walnut-700 dark:text-walnut-300 max-w-2xl mx-auto">
            {t("industries.subtitle")}
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {HOME_INDUSTRY_ITEMS.map((industry, index) => (
            <GlassCard
              key={index}
              className="p-6 text-center group cursor-pointer"
            >
              <div className="flex items-center justify-center mb-3 group-hover:scale-110 transition-transform duration-300">
                <industry.icon className="w-10 h-10 text-walnut-600 dark:text-walnut-400" />
              </div>
              <h3 className="text-sm font-semibold text-walnut-900 dark:text-white">
                {t(industry.nameKey)}
              </h3>
            </GlassCard>
          ))}
        </div>
      </div>
    </section>
  );
}
